"use client";
import Animation from "@/components/ui/animation";
import { Typography } from "@/components/ui/typography";
import { useScrollSpy } from "@/hooks/use-scroll-spy";
import type { PropsWithChildren } from "react";

const sectionIds = [
  "section1",
  "section2",
  "section3",
  "section4",
  "section5",
  "section6",
];

const MainProvider = ({ children }: PropsWithChildren) => {
  const activeId = useScrollSpy(sectionIds, 100);

  return (
    <Animation
      className="w-full flex relative bg-gradient-to-b from-[#1B1B1B] to-[#161616] rounded-3xl"
      viewPortAmount={0.01}
    >
      <div className="px-10 sticky h-fit top-0 py-16 max-sm:hidden">
        <ul className="flex flex-col gap-2">
          {[
            "01 / Бид",
            "02 / Арилжааны сигнал",
            "03 / Цахим ном",
            "04 / Видео хичээл",
            "05 / Giveaway",
            "06 / Түгээмэл асуугддаг асуултууд",
          ].map((label, i) => (
            <li key={i}>
              <Typography
                className={
                  activeId === `section${i + 1}` ? "!text-primary" : ""
                }
              >
                {label}
              </Typography>
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-gradient-to-b from-white/10 to-white/0 w-[1px] max-sm:hidden" />
      <div className="flex-1 px-8 py-16">{children}</div>
    </Animation>
  );
};

export default MainProvider;
